import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { CalendarEvent } from 'angular-calendar';

export enum SidenavActions {
  NewAppointment = 'New Appointment',
  NewParent = 'Create Parent',
  NewStudent = 'Create Student',
  NewBusiness = 'Create Business',
  SearchParent = 'Find Parent',
  SearchStudent = 'Find Student',
  SearchBusiness = 'Find Business',
  UpdateAppointment = 'Update Appointment',
  ReviewAppointment = 'Appointment Request',
  NewLocation = 'Create Location',
  SearchLocation = 'Find Location',
  NewMealPlan = 'Create Meal-plan',
  SearchMealPlan = 'Find Meal-plan',
  NewMeal = 'Create Meal',
  SearchMeal = 'Find Meal',
  NewService = 'Create Service',
  SearchService = 'Find Service',
  NewPractitioner = 'Create Teacher',
  SearchPractitioner = 'Find Teacher',
  NewGroup = 'Create Category',
  NewCommunityGroup = 'Create Community Group',
  SearchGroup = 'Find Category',
  NewAd = 'Create Ad',
  UpdateAd = 'Update Ad',
  ViewVideoTutorials = 'Video Tutorials'
}

@Injectable({
  providedIn: 'root'
})


export class SideNavService {
  sidenav: MatSidenav;
  sidenavAction: SidenavActions;
  loading = false;
  newParentEmail: string;
  public newBookingForm: CalendarEvent;
  constructor() { }

  setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  open(action: SidenavActions, newParentEmail?: string) {
      this.sidenavAction = action;
      this.newParentEmail = newParentEmail; 
      console.log(this.sidenavAction)
      return this.sidenav.open();
  }


  close() {
      this.loading = false;
      return this.sidenav.close();
  }

  toggle(): void {
    this.loading = false;
    this.sidenav.toggle();
  }

  
}
